import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

// Async thunk for listing campaigns
export const listCampaigns = createAsyncThunk(
    "listCampaigns",
    async (_, thunkAPI) => {
        try {
            const apiClient = new APIClient();
            const response = await apiClient.get(`api/v1/clients/notification/campaigns`);
            return response.data;
        } catch (error) {
            console.error("Error fetching campaigns:", error);
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

const listCampaignsSlice = createSlice({
    name: "listCampaigns",
    initialState: {
        loading: false,
        error: null,
        campaigns: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(listCampaigns.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(listCampaigns.fulfilled, (state, action) => {
                state.loading = false;
                state.campaigns = action.payload;
            })
            .addCase(listCampaigns.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default listCampaignsSlice.reducer; 